import { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import styles from './nav-menu-item.module.scss';

interface NavMenuItemProps {
  to: string;
  label?: string;
  icon?: ReactNode;
  isActive?: boolean;

  /**
   * Additional actions that can be triggered when a link is selected
   * i.g. to close a drawer or change a state value on navigation
   */
  onClick?: () => void;

  /**
   * React router state to pass around during navigation
   */
  state?: object;
}

export const NavMenuItem: FC<NavMenuItemProps> = ({ to, label, icon, onClick, isActive, state }) => (
  <Link className={styles['menu-item']} onClick={onClick} to={to} data-is-active={isActive} state={state}>
    {icon} <span>{label}</span>
  </Link>
);
